






















import { defineComponent, PropType } from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default defineComponent({
	components: {
		CtaButton,
		FontAwesomeIcon,
	},
	props: {
		size: {
			type: String as PropType<Size>,
			default: Size.TINY,
		},
		palette: {
			type: Number as PropType<ButtonPalettes>,
			default: ButtonPalettes.PRIMARY,
		},
	},
	setup() {
		return {};
	},
});
